import i18next from 'i18next';

export const translate = (resources: any, language?: string) => {
  const instance = i18next.createInstance(
    {
      interpolation: {
        escapeValue: false,
      },
      lng: language ?? 'tr',
      resources,
    },
    (err, t) => {},
  );

  const translateFunc = (key: string, params?: string[], fallback?: string): string => {
    let translation = instance.t(key, { defaultValue: fallback });

    if (params && params.length > 0) {
      params.forEach((param, index) => {
        translation = translation.replace('${' + index + '}', param);
      });
    }

    return translation;
  };

  return translateFunc;
};
